const floodableTypes = ["empty", "clue-arrow", "clue-area"];

export default floodableTypes;
